/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable */
import P from 'prop-types';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import GetApp from '@material-ui/icons/GetApp';
import useSWR from 'swr';
import { useRef, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Box, Button, IconButton, InputAdornment } from '@material-ui/core';
import { DateTime } from 'luxon';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import api from '../../service/api';
import CallModal from '../CallModal';
import ScheduleModal from '../ScheduleModal';
import DeadlineModal from '../DeadlineModal';
import CancelLeadModal from '../CancelLeadModal';
import SimpleModal from '../SimpleModal';
import { Container, FiReferralNotes, FormGroup, LoadingContainer, LoadingDiv } from './styles';
import { TextField, AutocompleteField, DateField, MaskedTextField, TextFieldAdorned } from '../FormFields';
import { RemoveMask } from '../../utils/phoneMask';
import UtilsTime from '../../utils/utilsTime';
import Loading from '../Loading';
import {
  handleQuotationQuiverMulti,
  handleQuotationQuiverMultiResidential,
  handleQuotationQuiverOn,
  handleQuotationQuiverOnResidential,
} from '../../service/quotation.service';
import {
  checkCEP,
  checkCPF,
  editLead,
  getLeadPermissions,
  goToNextStatus,
  handleCall,
  verify,
} from '../../service/lead.service';
import { months, offer } from '../../mock/leadInfo.com';
import GetProposal from '../GetProposal';
import { useAuth } from '../../hooks/useAuth';
import { dataCreate } from '../../service/data.service';
import useApp from '../../hooks/useApp';
import { fetcher } from '../../service/SWRFetcher';
import { editUser } from '../../service/user.service';
import { createClient, editClient, getClientByCpf } from '../../service/client.service';
import { NumericFormat } from 'react-number-format';
import AlertDialog from '../ConfirmationDialog';

export default function LeadForm({ type, leadCurrent, setOpen, mutate }) {
  const { user, updateUser } = useAuth();

  const {
    lead_contact_type,
    lead_sold,
    lead_lost_sale,
    lead_status,
    competitor_brokers,
    insurances,
    partners,
    time_to_finish_lead,
    crm_contact_accepted_types,
    setState,
  } = useApp();

  const {
    data: usersData,
    mutate: mutateUsers,
    isValidating,
  } = useSWR(`/users/inviter?${type == 'edit' && 'allUsers=true'}`, fetcher);

  // useEffect(() => {
  //   setState('loading', isValidating);
  // }, [isValidating]);

  // const { data: clientsData, mutate: mutateClients } = useSWR(user.role < 3 ? `/clients`: null, fetcher);

  // const context = useContext(MainContext);

  // const [user, setUser] = useState(null);
  const [captureDate, setCaptureDate] = useState(null);
  const [backupCar, setBackupCar] = useState(null);
  const [pagueMenos, setPagueMenos] = useState(null);
  const [seguroConteudo, setSeguroConteudo] = useState(null);
  const [status, setStatus] = useState(null);
  const [contact_type, setContact_type] = useState(null);
  const [initialDate, setInitialDate] = useState(null);
  const [quotedDate, setQuotedDate] = useState(null);
  const [soldDate, setSoldDate] = useState(null);
  const [sold, setSold] = useState(null);
  const [selectedSold, setSelectedSold] = useState(null);
  const [lost_sale, setLost_sale] = useState(null);
  const [competitor_broker, setCompetitor_broker] = useState(null);
  const [deadlinesModal, setDeadlinesModal] = useState(false);
  const [cancelLeadModal, setCancelLeadModal] = useState(false);
  const form = useRef(null);
  const [car, setCar] = useState(false);
  const [createError, setCreateError] = useState(false);
  const [openCallModal, setOpenCallModal] = useState(false);
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const [openPendencyModal, setOpenPendencyModal] = useState(false);
  const [openEndossoModal, setOpenEndossoModal] = useState(false);
  const [finish, setFinish] = useState(false);
  const [close, setClose] = useState(false);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [insurancesOptions, setInsurancesOptions] = useState([]);
  const [lead, setLead] = useState(false);
  const [check, setCheck] = useState(false);
  const [file, setFile] = useState(false);
  const [hideToast, setHideToast] = useState(false);
  const [openGetProposal, setOpenGetProposal] = useState(false);
  const [fillable, setFillable] = useState(null);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState(null);
  const [crmContactAcceptedTypes, setCrmContactAccepted] = useState(null);
  const [values, setValues] = useState({
    // -->inviter information<--
    inviter: null, //
    inviter_Phone: '', //
    partner: null, //
    insurance: null, //
    // -->client information<--
    proposal: '', //
    client_name: '', //
    client_cellphone: '', // c
    client_phone: '', //
    client_birth_date: '', //
    client_Cpf: '', //
    client_RG: '', //
    client_CEP: '', //
    client_address_street: '', //
    client_address_number: '', //
    client_address_comp: '', //
    client_address_district: '', //
    client_address_city: '', //
    client_address_state: '', //
    client_Email: '', //
    insurance_expiration: null, //
    // -->lead table<--
    proposal_date: null,
    product: '', //
    product_details: '', //
    product_chassis: '', //
    product_license_plate: '', //
    product_year: '', //
    product_brand: '',
    additional_information: '', //

    broker: null, // users ->removido
    status: null,
    state: null,
    contact_type: null,
    sold: null,
    lost_sale: null,
    pague_menos: null,
    backup_car: null,
    seguro_conteudo: null,
    endorsement_date: null,
    competitor_broker: null,
    attendance_on_time: null,
    indication_on_time: null,
    end_lead_date: null,
    first_call_date: null,
    lead_scheduling: null,
    arquivo_oc: null,
    date_fail: false,
    sold_date: '',
    sold_type: null,
    quoted_date: '',
    quoted_type: null,
    contact_date: '',
    sale_value: '',
    commission_percentage: '',
    nps_value: null,
    crm_contact_accepted: '',
  });

  const [statusFlow, setStatusFlow] = useState(null);
  function formatDate(date) {
    if (date == null) {
      return null;
    }
    const result = date.split('-');
    return result[2] + '-' + result[1] + '-' + result[0];
  }

  function formatDateSave(date) {
    const result = date.split('/');
    if (result[2]) {
      return result[2] + '-' + result[1] + '-' + result[0];
    } else {
      return date;
    }
  }

  const Loadingg = (value) => {
    setLoading(value);
  };

  const clear = async () => {
    setCar(false);
    setPartnersOptions([]);
    const now = new Date().toISOString().split('.')[0];
    // const res = await context.auth.getUserInfo();

    setValues({
      ...values,
      inviter: type == 'createUser' ? user?.data : null,
      inviter_Phone: type == 'createUser' ? user.phone : '',
      channel_id: type == 'createUser' ? user.channel : null,
      partner: null,
      insurance: null,
      proposal: '',
      client_name: '',
      client_cellphone: '',
      client_phone: '',
      client_birth_date: '',
      client_Cpf: '',
      client_Rg: '',
      client_CEP: '',
      client_address_street: '',
      client_address_number: '',
      client_address_comp: '',
      client_address_district: '',
      client_address_city: '',
      client_address_state: '',
      client_Email: '',
      proposal_date: now,
      insurance_expiration: null,
      product: '',
      product_details: '',
      product_chassis: '',
      product_license_plate: '',
      product_year: '',
      product_brand: '',
      additional_information: '',
      date_fail: false,
      nps_value: null,
    });
  };

  // #region fetching

  const updateLead = async () => {
    try {
      const tempLead = await api.get(`/leads/${lead?.id}`);
      setLead(tempLead.data.data);
    } catch (error) {
      //
    }
  };
  const getPermissions = async () => {
    const permissionsResponse = await getLeadPermissions(leadCurrent.id);
    setPermissions(permissionsResponse);
  };

  useEffect(() => {
    (async () => {
      Loadingg(true);
      setLead(leadCurrent);

      if (type == 'edit') {
        const response = await api.get(`/leadChannel/${leadCurrent?.id}`);
        setStatusFlow(response.data.data.lead.attendance_flow.status_flow);
      }

      if (leadCurrent) {
        await getPermissions();
      }
      // context.getters.getDashboard();
      // getUserInfo().then((res) => setUser(res.data));
      const removeContactType = lead_contact_type.filter((item) => item.value !== 'Whatsapp/Telefone');
      const filteredContactTypes = removeContactType?.sort((a, b) => {
        // var_id 4 sempre no final do array !!!
        if (a.var_id == '4') return 1;
        if (b.var_id == '4') return -1;

        return;
      });
      setContact_type(filteredContactTypes?.map((ct) => ({ id: ct.var_id, name: ct.value })));
      setSold(lead_sold?.map((s) => ({ id: s.var_id + 1, name: s.value })));
      setLost_sale(lead_lost_sale?.map((ls) => ({ id: ls.var_id, name: ls.value })));
      setStatus(lead_status?.map((st) => ({ id: st.var_id, name: st.value })));
      setCrmContactAccepted(crm_contact_accepted_types?.map((st) => ({ id: st.var_id, name: st.value })));
      setCompetitor_broker(competitor_brokers?.map((st) => ({ id: st.var_id, name: st.value })));

      if (leadCurrent != null) {
        setCaptureDate(!!leadCurrent.capture_date && leadCurrent.capture_date);
      }

      if (type === 'createUser') clear();
      Loadingg(false);
    })();
  }, [user]);

  useEffect(() => {
    if (usersData && lead) {
      const inviterInfo = usersData.find((i) => i.id === lead?.inviter_id);
      setValues({ ...values, inviter: inviterInfo || null, inviter_Phone: inviterInfo?.phone || '' });
    }
  }, [usersData, lead]);

  useEffect(() => {
    if (!loading && usersData) {
      if (type !== 'edit') {
        const now = new Date().toISOString().split('.')[0];
        setValues({ ...values, proposal_date: now });
        if (type == 'createUser') {
          setValues({
            ...values,
            inviter: user?.data,
            inviter_Phone: user.phone,
            channel_id: user.channel,
            proposal_date: now,
          });
          // context.auth.getUserInfo().then((res) => {
          //   // setPartnersOptions(res.data.partners);
          // });
        }
      }
      if (type === 'edit' && lead) {
        // const inviterInfo = usersData ? usersData.find((i) => i.id === lead?.inviter_id) : user.data;
        const inviterInfo = usersData ? usersData.find((i) => i.id === lead?.inviter_id) : {};
        const insuranceInfo = insurances.find((ins) => ins.id === lead?.insurance_id);
        const client_name = lead.client ? lead?.client?.name : lead.client_info?.client_name;
        const client_phone = lead.client ? lead?.client?.phone : lead.client_info?.client_phone?.toString();
        const client_cellphone = lead.client ? lead?.client?.cellphone : lead.client_info?.client_cellphone?.toString();
        const client_email = lead.client ? lead?.client?.mail : lead.client_info?.client_email;
        const client_cpf = lead.client ? lead?.client?.cpf : lead.client_info?.client_cpf;
        const client_birth_date = lead.client ? lead?.client?.birth_date : lead.client_info?.birth_date?.split('T')[0];
        const client_cep = lead.client ? lead?.client?.address?.cep : lead.client_info?.cep;
        const client_address_street = lead.client ? lead?.client?.address?.street : lead.client_info?.address_street;
        const client_address_number = lead.client ? lead?.client?.address?.number : lead.client_info?.address_number;
        const client_address_comp = lead.client ? lead?.client?.address?.address_comp : lead.client_info?.address_comp;
        const client_address_uf = lead.client ? lead?.client?.address?.state : lead.client_info?.address_uf;
        const client_rg = lead.client ? lead?.client?.rg : lead.client_info?.rg;
        const client_address_district = lead.client
          ? lead?.client?.address?.district
          : lead.client_info?.address_district;
        const client_address_city = lead.client ? lead?.client?.address?.city : lead.client_info?.address_city;

        /* setBackupCar(offer.find((o) => o.id == lead?.backup_car?.toString()) || null); */
        setPagueMenos(offer.find((o) => o.id == lead?.pague_menos?.toString()) || null);
        /* setSeguroConteudo(offer.find((o) => o.id == lead?.seguro_conteudo?.toString()) || null); */
        setSelectedSold((lead?.sold !== null && sold?.find((sd) => sd.id == lead?.sold + 1)) || null);

        setInitialDate(lead?.contact_date || '');
        setQuotedDate(lead?.quoted_date || '');
        setSoldDate(lead?.sold_date || '');

        setValues({
          ...values,
          inviter: inviterInfo || null,
          inviter_Phone: inviterInfo?.phone || '', //
          partner: lead?.partner || null, //
          insurance: insuranceInfo || null, //
          proposal: lead?.proposal || '', //
          client_name: client_name || '', //
          client_cellphone: lead?.client?.cellphone || '', // c
          client_phone: client_phone || '', //
          client_cellphone: client_cellphone || '', //
          client_birth_date: client_birth_date || '', //
          client_Cpf: client_cpf, //
          client_Rg: client_rg || '', //
          client_CEP: client_cep || '', //
          client_address_street: client_address_street || '', //
          client_address_number: client_address_number || '', //
          client_address_comp: client_address_comp || '', //
          client_address_district: client_address_district || '', //
          client_address_city: client_address_city || '', //
          client_address_state: client_address_uf || '', //
          client_Email: client_email || '', //
          insurance_expiration: months.find((s) => s.id === lead?.insurance_expiration) || null, //
          proposal_date: lead?.proposal_date || null,
          product: lead?.product || '', //
          product_details: lead?.product_details?.details || '', //
          product_chassis: lead?.product_details?.chassis || '', //
          product_license_plate: lead?.product_details?.license_plate || '', //
          product_year: lead?.product_details?.year || '', //
          product_brand: lead?.product_details?.brand || '',
          additional_information: lead?.additional_information || '', //
          broker: lead?.broker || null,
          status: status?.find((s) => s.id === lead?.status) || '',
          state: lead?.state || null,
          contact_type: contact_type?.find((ct) => ct.id === lead?.contact_type) || '',
          sold: (lead?.sold !== null && sold?.find((sd) => sd.id == lead?.sold + 1)) || null,
          lost_sale: lost_sale?.find((ls) => ls.id == lead?.lost_sale) || null,
          pague_menos: offer.find((o) => o.id == lead?.pague_menos?.toString()) || null,
          backup_car: offer.find((o) => o.id == lead?.backup_car?.toString()) || null,
          seguro_conteudo: offer.find((o) => o.id == lead?.seguro_conteudo?.toString()) || null,
          attendance_on_time: lead?.attendance_on_time || null,
          end_lead_date: lead?.end_lead_date || null,
          lead_scheduling: lead?.lead_scheduling || null,
          first_call_date: lead?.first_call_date || null,
          competitor_broker: competitor_broker?.find((cb) => cb.id == lead?.competitor_broker) || null,
          sold_type: contact_type?.find((cb) => cb.id == lead?.sold_type) || null,
          quoted_type: contact_type?.find((cb) => cb.id == lead?.quoted_type) || null,
          sale_value: lead?.sale_value ? lead?.sale_value.replaceAll('.', ',') : '',
          commission_percentage: lead?.commission_percentage || '',
          nps_value: lead?.nps_value,
          crm_contact_accepted:
            lead?.crm_contact_accepted !== null
              ? crmContactAcceptedTypes?.find((data) => data?.id === Number(lead?.crm_contact_accepted))
              : null,
        });

        if (status && lost_sale && contact_type && sold && competitor_broker && lead) {
          setCheck(true);
        }
      }
    }
  }, [loading, usersData]);
  // }, [status, lost_sale, contact_type, sold, competitor_broker, lead]);

  // #endregion

  useEffect(() => {
    if (values.insurance) {
      if (values.insurance?.id >= 1 && values.insurance?.id <= 3) setCar(true);
      else setCar(false);
    }
  }, [values.insurance]);

  useEffect(() => {
    (async () => {
      if (type !== 'edit' && fillable != null) {
        const now = DateTime.now();
        const proposalDate = DateTime.fromISO(fillable.proposal_date);
        // eslint-disable-next-line no-unused-vars
        const diffProposalNow = now.diff(proposalDate, ['hours']);
        await setValues({
          ...values,
          partner: partners.find((p) => p.id == fillable.partner_id),
          proposal: fillable.proposal || '',
          client_name: fillable.client_informations.name || '',
          client_Cpf: fillable.client_informations.cpf || '',
          client_Rg: fillable.client_informations.rg || '',
          client_birth_date: fillable.client_informations.birth_date.split('T')[0] || '',
          client_CEP: fillable.client_informations.address.cep || '',
          client_address_street: fillable.client_informations.address.street || '',
          client_address_number: fillable.client_informations.address.number || '',
          client_address_comp: fillable.client_informations.address.comp || '',
          client_address_district: fillable.client_informations.address.district || '',
          client_address_city: fillable.client_informations.address.city || '',
          client_address_state: '',
          client_cellphone: fillable.client_informations.cellphone || '',
          client_phone: fillable.client_informations.phone || '',
          client_Email: fillable.client_informations.email || '',
          proposal_date: fillable.proposal_date || '',
          product: fillable.product_informations.name || '',
          product_chassis: fillable.product_informations.chassis || '',
          product_license_plate: fillable.product_informations.license_plate || '',
          product_year: fillable.product_informations.year || '',
          product_brand: fillable.product_informations.brand || '',
          insurance: insurances.find((i) => i.id == fillable.insurance.id),
        });
      }
    })();
  }, [fillable]);

  useEffect(() => {
    if (!partners.length) return;

    if (type !== 'edit') setValues({ ...values, partner: null, insurance: null });

    if (!values.inviter) return setPartnersOptions([]);
    let insurance = null;

    const partnersFilered = partners?.filter((p) => {
      let found = false;
      p.users.forEach((u) => {
        if (u.id === values.inviter.id) {
          found = true;
        }
      });
      return found;
    });

    if (!values.inviter?.roles?.length) return;

    if (values.inviter?.roles[0].id <= 2) {
      insurance = insurances;
    } else {
      insurance = values.inviter.channel.id === 1 ? insurances.filter((i) => i.id <= 3) : insurances;
    }

    setInsurancesOptions(insurance);
    setPartnersOptions(partnersFilered);
  }, [values.inviter, partners]);

  const checkInviter = (inviterValue) => {
    setValues({
      ...values,
      inviter: inviterValue,
      inviter_Phone: inviterValue?.phone,
      channel_id: inviterValue?.channel.id,
    });
  };

  // #region Handles

  const handleSave = async () => {
    // console.log("lead", lead);
    // console.log("leadCurrent", leadCurrent);
    // return;

    // deprecated 09/07/2024
    // if (values?.contact_type?.name != 'Presencial' && values?.quoted_type?.name == 'Presencial') {
    //   return toast.warning('Forma que apresentou a proposta inválida');
    // }

    // if (values?.quoted_type?.name != 'Presencial' && values?.sold_type?.name == 'Presencial') {
    //   return toast.warning('Forma que recebeu a proposta inválida');
    // }

    if (values.inviter.channel.id == 1 && !values.proposal && type !== 'edit') {
      toast.warning('Proposta não selecionada');
      return;
    }

    try {
      if (values.inviter)
        await editUser({ phone: values.inviter_Phone && RemoveMask(values.inviter_Phone) }, values.inviter.id);
      // updateUser();

      let clientId;
      let client;

      if (lead?.client?.id) {
        client = lead?.client;
      } else {
        if (values.client_Cpf && values.client_Cpf.length > 0) {
          client = await getClientByCpf(values.client_Cpf);
        } else {
          client = null;
        }
      }

      const clientData = {
        name: values.client_name,
        phone: (values.client_phone && RemoveMask(values.client_phone)) || ' ',
        cellphone: (values.client_cellphone && RemoveMask(values.client_cellphone)) || ' ',
        mail: values.client_Email,
        cpf: (values.client_Cpf && RemoveMask(values.client_Cpf)) || '',
        rg: (values.client_Rg && RemoveMask(values.client_Rg)) || '',
        birth_date: formatDateSave(values.client_birth_date) || '',
        address: {
          cep: (values.client_CEP && RemoveMask(values.client_CEP)) || null,
          street: values.client_address_street || null,
          number: values.client_address_number || null,
          comp: values.client_address_comp || null,
          district: values.client_address_district || null,
          city: values.client_address_city || null,
          state: values.client_address_state || null,
        },
      };
      if (!client) {
        if (values.inviter?.id != 6) {
          const data = await createClient(clientData);
          clientId = data.id;
        } else if (values.inviter?.id == 6 && values.client_Cpf) {
          const data = await createClient(clientData);
          clientId = data.id;
        }
      } else {
        await editClient(clientData, client.id);
        clientId = client.id;
      }
      let whatsappCallStatus = 1;
      if (type === 'edit') whatsappCallStatus = lead.status == 2 && values.contact_type ? 3 : values.status.id;
      if (values?.status?.id == 6) {
        whatsappCallStatus = 6;
      }

      const leadData = {
        proposal: values.proposal || null,
        proposal_date: values.proposal_date,
        product: values.product,
        product_details: {
          brand: values.product_brand,
          license_plate: values.product_license_plate,
          chassis: values.product_chassis,
          year: values.product_year,
          details: values.product_details,
        },
        channel_id: values.channel_id,
        inviter_id: values.inviter?.id,
        broker_id: values.broker?.id,
        insurance_id: values.insurance.id,
        insurance_expiration: values.insurance_expiration ? values.insurance_expiration?.id : 0,
        partner_id: values.partner.id,
        additional_information: values.additional_information || ' ',
        client_id: clientId,
        contact_type: (values.contact_type && values.contact_type.id) || null,
        sold: selectedSold?.id === 1 ? 0 : selectedSold?.id === 2 ? 1 : null,
        lost_sale: selectedSold?.id == 1 ? values.lost_sale?.id : null,
        /* backup_car: backupCar?.id.toString() || null, */
        pague_menos: pagueMenos?.id.toString() || null,
        /* seguro_conteudo: seguroConteudo?.id.toString() || null, */
        // status: whatsappCallStatus || null,
        state: values.state || null,
        endorsement_date: values.endorsement_date || null,
        competitor_broker: values.competitor_broker?.id || null,
        attendance_on_time: values.attendance_on_time || null,
        // indication_on_time: values.indication_on_time || null,
        end_lead_date: values.end_lead_date,
        first_call_date: values.first_call_date,
        date_fail: values.date_fail,
        // arquivo_oc: values.arquivo_oc,
        pending_sell: values.pending_sell || null,
        negociate: values.negociate || null,
        sold_date: soldDate,
        sold_type: (values.sold_type && values.sold_type.id) || null,
        quoted_date: quotedDate,
        quoted_type: (values.quoted_type && values.quoted_type.id) || null,
        contact_date: initialDate,
        sale_value: values.sale_value.replaceAll('.', '').replaceAll(',', '.'),
        commission_percentage: values.commission_percentage,
        crm_contact_accepted: values?.crm_contact_accepted ? values?.crm_contact_accepted?.id : null,
      };

      if (type === 'edit') {
        const saveResponse = await editLead(leadData, lead?.id);
        // console.log(saveResponse, lead_status?.find((st) => st.var_id == saveResponse.status));
        const newStatus = lead_status?.find((st) => st.var_id == saveResponse.status);
        await getPermissions();
        if (newStatus) setValues({ ...values, status: { id: newStatus.var_id, name: newStatus.value } });
        if (!hideToast) toast.success('Lead salvo com sucesso!');
        else setHideToast(false);
        updateLead();
      } else {
        const editResponse = await dataCreate('/leads', leadData);
        if (editResponse) {
          toast.success('Lead criado com sucesso!');
          // if (editResponse.indication_on_time == 0) toast.warning('Lead indicada fora do prazo!');
        }
        // if (leadData.indication_on_time === '0') toast.warning('Lead indicada fora do prazo!');
        clear();
      }
      if (values.state == 3) {
        setOpen(false);
      }
      if (mutate) mutate();
    } catch (error) {
      console.log(error);

      if (error.response.status === 401) {
        toast.warning('Proposta já registrada');
        return;
      }
      let msg;
      if (error?.statusError === 1) {
        msg = error.message;
        setCreateError(true);
      } else {
        msg = error.response.data.message;
        if (!msg) {
          msg = 'Falha ao criar lead! verifique os campos preenchidos';
        }
      }

      toast.warning(msg);
    }
  };

  const handleChange = (event) => {
    if (event.target.name === 'commission_percentage') {
      const value = Math.max(0, Math.min(100, Number(event.target.value)));

      setValues({
        ...values,
        [event.target.name]: value,
      });
    } else {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleChangeAutoComplete = (event, newValue, variable) => {
    // console.log(newValue, variable);
    // if (newValue) {
    setValues({
      ...values,
      [variable]: newValue,
    });
    if (variable === 'inviter') checkInviter(newValue);

    if (newValue != null) {
      if (variable == 'contact_type' && newValue.id == 4) {
        setValues({
          ...values,
          contact_type: newValue,
          quoted_type: newValue,
          sold_type: newValue,
        });

        handleSetDefaultData(newValue.id, 'contact_type');

        handleSetDefaultData(newValue.id, 'quoted_date');

        handleSetDefaultData(newValue.id, 'sold_date');
      }

      if (variable == 'quoted_type' && newValue.id == 4) {
        setValues({
          ...values,
          quoted_type: newValue,
          sold_type: newValue,
        });

        handleSetDefaultData(newValue.id, 'quoted_date');

        handleSetDefaultData(newValue.id, 'sold_date');
      }
    }
  };

  // const onlyValidContactyType = (contacty_type, type) => {
  /**
   * @deprecated 09/07/2024
   */
  //   const contactTypeValue = values?.contact_type?.name;
  //   const quotTypeValue = values?.quoted_type?.name;

  //   if (contactTypeValue != 'Presencial') {
  //     return contact_type?.filter((type) => type?.name != 'Presencial');
  //   }

  //   if (type == 'sold_type' && quotTypeValue != 'Presencial') {
  //     return contact_type?.filter((type) => type?.name != 'Presencial');
  //   }

  //   return contacty_type;
  // };

  const handlePendency = async () => {
    // setValues({ ...values, status: status.find((s) => s.id === 5) });
    setValues({ ...values, pending_sell: true });
    setFinish(true);
  };

  const handleQuotationAuto = async (event, newValue) => {
    const url = `https://www.corretor-online.com.br/canalcliente/index.htm?ParamWS=ZTc5N2YwNW1jbXBlY3FLdGs3OWZjS2l6YTNDd3YxcEJmbEZKWW82dHFiRmFjbjVPZnBGdG1wR1pxWkdSV21sUmptMUdTVWxCc1pXK2ZubDV1VjV5ZmxGUmFrbCtrVzUrWGs1bVhpcVFuNnVYVktTdmxwcVNXUUxTbFpoVG5Bb0E=`;
    window.open(url);
  };

  const handleFinishLead = async () => {
    if (permissions?.next_status < 5 && !values.contact_type) {
      toast.warning('Você não tem permissão para finalizar essa lead devido a mudança no tipo de contato!');
      return;
    }

    if (permissions?.can_finish && !values.crm_contact_accepted) {
      toast.warning('Complete as Informações da Indicação F&I!');
      return;
    }

    if (statusFlow !== null && lead?.channel_id !== 7) {
      if (statusFlow.indexOf(3) < statusFlow.indexOf(4)) {
        if (DateTime.fromSQL(initialDate) > DateTime.fromSQL(quotedDate)) {
          toast.warning('Data de contato deve ser menor que a data de cotação');
          return;
        }
      } else if (statusFlow.indexOf(4) < statusFlow.indexOf(3)) {
        if (DateTime.fromSQL(quotedDate) > DateTime.fromSQL(initialDate)) {
          toast.warning('Data de cotação deve ser menor do que a data de contato');
          return;
        }
      }
    }

    if (captureDate) {
      const captureDateObject = DateTime.fromSQL(captureDate);

      if (captureDateObject > DateTime.fromSQL(initialDate)) {
        toast.warning('Data de contato deve ser maior que ' + formatDateObject(captureDateObject));
        return;
      }

      if (captureDateObject > DateTime.fromSQL(soldDate)) {
        toast.warning('Data de venda deve ser maior que ' + formatDateObject(captureDateObject));
        return;
      }

      if (captureDateObject > DateTime.fromSQL(quotedDate) && lead?.channel_id !== 7) {
        toast.warning('Data de cotação deve ser maior que ' + formatDateObject(captureDateObject));
        return;
      }
    }

    if (DateTime.fromSQL(soldDate) < DateTime.fromSQL(initialDate)) {
      toast.warning('Data de venda/não venda deve ser maior do que a data de cotação');
      return;
    }

    if (DateTime.fromSQL(soldDate) < DateTime.fromSQL(quotedDate)) {
      toast.warning('Data de venda/não venda deve ser maior do que a data de contato');
      return;
    }

    if (values.inviter?.id != 6) {
      verify(values, setValues, car);
      if (!selectedSold) {
        toast.warning('Informe o Status da venda');
        return;
      }
      if (selectedSold.id === 1 && !values.lost_sale) {
        toast.warning('Informe o Motivo da não venda');
        return;
      }
      if (!pagueMenos) {
        toast.warning('Informe se foi oferecido o Seguro Franquia');
        return;
      }
      if (values.lost_sale?.id == 5) {
        setOpenEndossoModal(true);
        return;
      }
    }

    if (permissions?.can_call) {
      if (!initialDate) {
        toast.warning('Informe a data do contato');
        return;
      }
    }

    if (lead.quoted == 1) {
      if (!values.quoted_type) {
        toast.warning('Informe a forma que apresentou a proposta');
        return;
      }

      if (!quotedDate) {
        toast.warning('Informe a data da cotação');
        return;
      }
    }

    if (permissions?.can_finish) {
      if (selectedSold?.id == 2) {
        if (!values.competitor_broker) {
          toast.warning('Informe a seguradora');
          return;
        }

        if (!values.sale_value) {
          toast.warning('Informe o valor da venda');
          return;
        }

        if (!values.commission_percentage) {
          toast.warning('Informe a porcentagem da comissão');
          return;
        }
      }

      if (!values.sold_type) {
        toast.warning('Informe a forma que recebeu a resposta da venda/não venda');
        return;
      }

      if (!soldDate) {
        toast.warning('Informe a data da venda/não venda');
        return;
      }
    }

    if (selectedSold?.id == 1) {
      if (!values.lost_sale) {
        toast.warning('Informe o motivo de não venda');
        return;
      }
    }

    const finishTime = DateTime.now().toISO().split('.')[0];
    const fullTime = UtilsTime(lead?.create_lead_date.split(' ').join('T'), finishTime);

    setValues({
      ...values,
      state: 3,
      status: { id: 6, name: 'Finalizado' },
      attendance_on_time: fullTime.hours + fullTime.minute / 60 < time_to_finish_lead.value ? 1 : 0,
      end_lead_date: finishTime,
    });
    setFinish(true);
  };

  // #endregion

  // CALL HANDLE SAVE
  useEffect(() => {
    if (finish != false) {
      handleSave();
      setFinish(false);
    }
  }, [finish]);

  useEffect(() => {
    if (close != false) {
      handleFinishLead();
      setClose(false);
    }
  }, [close]);

  const formatDateObject = (date) => {
    let stringDate = date.toISO().split('T');

    let dateDays = stringDate[0].split('-');
    let dateTime = stringDate[1].slice(0, 7);

    const day = dateDays[2];
    const month = dateDays[1];
    const year = dateDays[0];

    dateDays = `${day}/${month}/${year}`;

    return `${dateDays} ${dateTime}`;
  };

  const fileUpload = async (event) => {
    // console.log('fileUpload', event.target.files);
    if (event.target.files[0] == null) {
      return;
    }
    if (event.target.files[0].type != 'application/pdf') {
      setFile(null);
      toast.warning('Formato de arquivo inválido! Somente arquivos PDF');
    } else {
      setFile(event.target.files[0]);
      try {
        const data = {
          lead_id: leadCurrent.id,
          file: event.target.files[0],
        };
        let formData = new FormData();
        for (var key in data) {
          formData.append(key, data[key]);
        }
        const token = localStorage.getItem('token');
        const resp = await api.post(`/leads/file`, formData, {
          headers: { 'Content-Type': 'multipart/form-data', authorization: `Bearer ${token}` },
        });
        toast.success('Arquivo enviado com sucesso');
        setFile(null);
      } catch (error) {
        toast.error('Erro ao enviar arquivo');
        console.log('error', error);
        setFile(null);
      }
    }
  };
  const downloadFile = async () => {
    // console.log('downloadFile');
    const token = localStorage.getItem('token');
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', authorization: `Bearer ${token}` },
    };
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/leads/fileDownload?lead_id=${leadCurrent.id}`, requestOptions)
      .then((res) => {
        // console.log('res', res);
        if (res.status === 400) {
          return;
        } else {
          return res.blob();
        }
      })
      .then((blob) => {
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', leadCurrent.id + ' OF.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('Fazendo Download do arquivo...');
      })
      .catch((error) => {
        toast.error('Erro ao Fazer Download do Arquivo');
        console.log('error', error);
      });
  };

  const handleSetDefaultData = (id, type) => {
    const defaultDate = DateTime.now().toISO().split('.')[0];

    if (type === 'contact_type' && !initialDate) {
      setInitialDate(defaultDate);
    }

    if (type === 'quoted_date' && !quotedDate) {
      setQuotedDate(defaultDate);
    }

    if (type === 'sold_date' && !soldDate) {
      setSoldDate(defaultDate);
    }
  };

  // Buttons
  const ButtonDiv = () => (
    <div className="form-buttons" style={{ margin: '14px 0' }}>
      {/* <Button onClick={() => console.log(values)}>Teste</Button> */}
      {type !== 'edit' &&
        (values.inviter?.roles[0]?.id === 7 || values.inviter?.roles[0]?.id === 1) &&
        values.partner?.release_quote && (
          <Button
            onClick={() => {
              handleQuotationAuto();
            }}
            variant="contained"
            color="default">
            Simular cotação
          </Button>
        )}
      {type === 'edit' && (
        <>
          {values?.insurance?.id == '25' && (
            <Button
              variant="contained"
              color="default"
              onClick={() => {
                setCancelLeadModal(true);
              }}>
              Cancelamento no Quiver
            </Button>
          )}

          {values?.insurance?.id != '25' && (
            <Button
              variant="contained"
              color="default"
              onClick={() => {
                verify(values, setValues, car, permissions);
                setClose(true);
              }}
              disabled={
                !permissions?.can_finish
                // values.inviter?.id == 6
                //   ? false
                //   : !values.contact_type ||
                //     (values.contact_type.id != 4 &&
                //       (values.insurance.id <= 4 ? values.status.id < 4 : values.status.id < 3))
              }>
              Finalizar
            </Button>
          )}

          {user?.role === 1 && values?.insurance?.id != '25' && (
            <Button
              variant="contained"
              color="default"
              onClick={() => {
                setDeadlinesModal(true);
              }}>
              Alterar Prazos
            </Button>
          )}

          {values?.insurance?.id != '25' && (
            <>
              <Button
                style={{ width: 'auto' }}
                variant="contained"
                color="default"
                onClick={() => setOpenScheduleModal(true)}
                disabled={!values.contact_type || values.contact_type.id < 1}>
                {values.lead_scheduling && values.lead_scheduling.status === 0 ? 'Agendamento' : 'Agendar Retorno'}
              </Button>
              <Button
                style={{ width: 'auto' }}
                onClick={() => setOpenPendencyModal(true)}
                variant="contained"
                color="default"
                disabled={permissions?.next_status < 5}>
                Vendido com pendência
              </Button>
              {permissions?.can_quote.quote_type != null && (
                <Button
                  onClick={async () => {
                    switch (permissions?.can_quote.quote_type) {
                      case 1:
                        await handleQuotationQuiverMulti(values, setValues, lead);
                        break;
                      case 2:
                        await handleQuotationQuiverMultiResidential(values, setValues, lead);
                        break;
                      default:
                        setAlert({
                          open: true,
                          title: 'Cotação',
                          msg: 'Cotação realizada com sucesso',
                        });

                        const newStatus = await goToNextStatus(lead?.id);

                        setValues({ ...values, status: { id: newStatus.var_id, name: newStatus.value } });
                        await editLead({ quoted: 1 }, lead?.id);
                        await getPermissions();
                        return;
                    }
                    await getPermissions();
                    setFinish(true);
                  }}
                  variant="contained"
                  color="default"
                  disabled={!permissions?.can_quote.able_to_quote || false}>
                  Cotação
                </Button>
              )}
              {/* {values.insurance?.id == 4 && (
              <Button
                onClick={() => handleQuotationQuiverMultiResidential(values, setValues, lead)}
                variant="contained"
                color="default"
                // disabled={lead.status < 3}
                disabled={!permissions?.can_quote || false}
                >
                Cotação
              </Button>
            )} */}
            </>
          )}
          {permissions?.can_negociate && (
            <Button
              onClick={async () => {
                // const newStatus = await goToNextStatus(lead?.id);
                setValues({ ...values, status: { id: 2, name: 'Negociação' }, negociate: true });
                setFinish(true);
              }}
              variant="contained"
              color="default"
              // disabled={lead.status < 3}
              disabled={!permissions?.can_negociate || false}>
              Negociação
            </Button>
          )}

          <Button
            onClick={() => {
              // setHideToast(true);
              // setFinish(true);
              setOpenCallModal(true);
            }}
            variant="contained"
            color="default"
            disabled={!permissions?.can_call || false}>
            Ligar
          </Button>
        </>
      )}
      <Button type="submit" variant="contained" color="default">
        Salvar
      </Button>

      {type !== 'edit' && (
        <Button onClick={clear} variant="contained" color="default">
          Descartar
        </Button>
      )}
    </div>
  );

  const canRenderProposalSearch = (inviter) => {
    if (!inviter?.status) return false;

    /**
     * Retorno verdadeiro
     * 1. Ser channel 1
     * 2. Ter technical team e ter o grupo carbel dentro dos canais do time
     */

    if (inviter?.channel_id == 1) return true;

    const { technical_team } = inviter;

    if (!technical_team) return false;

    if (!technical_team?.channels?.find((ch) => ch?.id == 1)) return false;

    return true;
  };

  const date = new Date();
  const lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString().slice(0, 10) + 'T23:59';

  const [alert, setAlert] = useState({
    open: false,
    msg: '',
    title: '',
  });

  const handleOpenGetProposals = () => {
    setOpenGetProposal(true);
  };

  return (
    <>
      <AlertDialog
        open={alert.open}
        msg={alert.msg}
        title={alert.title}
        ok={() => {
          console.log(alert.msg);
          setAlert({ open: false, msg: '', title: '' });
        }}
      />
      {/* {(type === 'edit' && !check) || (type === 'edit' && !user) ? ( */}
      {loading && (
        <LoadingDiv>
          <Loading />
        </LoadingDiv>
      )}

      {usersData && (
        <Container>
          <GetProposal
            open={openGetProposal}
            setOpen={setOpenGetProposal}
            setFillable={setFillable}
            inviter={values.inviter}
          />
          {lead && (
            <>
              <CallModal
                open={openCallModal}
                setOpen={setOpenCallModal}
                clientName={values.client_name}
                clientPhones={[values.client_phone, values.client_cellphone]}
                broker={values.broker}
                // next={() => handleCall(values, setValues, setFinish, status)}
              />
              <ScheduleModal
                open={openScheduleModal}
                setOpen={setOpenScheduleModal}
                lead={lead}
                next={() => {
                  setFinish(true);
                }}
              />
              <SimpleModal
                title="Registrar Pendência"
                fieldName="OBSERVAÇÃO"
                open={openPendencyModal}
                setOpen={setOpenPendencyModal}
                value={values.additional_information}
                onChange={(e) => setValues({ ...values, additional_information: e.target.value })}
                next={handlePendency}
              />
              <DeadlineModal
                title="Alterar Prazos - Administrador"
                open={deadlinesModal}
                setOpen={setDeadlinesModal}
                value={leadCurrent}
              />
              <CancelLeadModal
                title="Confirmar Lead Cancelado?"
                open={cancelLeadModal}
                setOpen={setCancelLeadModal}
                value={leadCurrent}
                setOpenLeadForm={setOpen}
              />
              <SimpleModal
                title="Agendamento endosso"
                fieldName="Data de expiração do seguro do cliente"
                open={openEndossoModal}
                setOpen={setOpenEndossoModal}
                value={values.endorsement_date}
                finish
                finishValue={values.date_fail}
                finishonChange={(e) => setValues({ ...values, date_fail: e.target.checked })}
                onChange={(e) => setValues({ ...values, endorsement_date: e.target.value })}
                next={() => {
                  const finishTime = DateTime.now().toISO().split('.')[0];
                  const fullTime = UtilsTime(lead?.create_lead_date.split(' ').join('T'), finishTime);
                  setValues({
                    ...values,
                    state: 3,
                    // status: { id: 6, name: 'Finalizado' },
                    attendance_on_time: fullTime.hours + fullTime.minute / 60 < time_to_finish_lead.value ? 1 : 0,
                    end_lead_date: finishTime,
                  });
                  setFinish(true);
                  setOpen(false);
                }}
                date
              />
            </>
          )}
          <form
            ref={form}
            onSubmit={(e) => {
              e.preventDefault();
              verify(values, setValues, car);
              setFinish(true);
            }}>
            <ButtonDiv />
            {type === 'edit' && values?.insurance?.id != '25' && (
              <div>
                <h2>Informações do Corretor - Lead: {lead?.id}</h2>
                <span>
                  <h4>Status: {values.status && values.status.name}</h4>
                </span>
                <div className="form">
                  <FormGroup dark>
                    <AutocompleteField
                      medium
                      className="control g"
                      valueText={values.broker ? values.broker.name : ''}
                      options={usersData ? usersData.filter((u) => u.roles[0]?.id <= 3) : [values.broker]}
                      value={values.broker || null}
                      varibleName="broker"
                      onChange={handleChangeAutoComplete}
                      label="CORRETOR"
                      disabled={user?.role >= 2}
                      required
                    />

                    {permissions?.can_call && (
                      <AutocompleteField
                        medium
                        valueText={values.contact_type ? values.contact_type.name : ''}
                        options={contact_type}
                        value={values.contact_type || null}
                        varibleName="contact_type"
                        onChange={(event, newValue, variable) => {
                          if (newValue) {
                            handleSetDefaultData(newValue.id, 'contact_type');
                            handleChangeAutoComplete(event, newValue, variable);
                          }
                        }}
                        label="Forma de contato inicial"
                        // required={lead.status >= 3}
                      />
                    )}

                    {permissions?.can_call && (
                      <TextField
                        id="datetime-local"
                        label="Data do contato *"
                        type="datetime-local"
                        value={initialDate || ''}
                        onChange={(e) => setInitialDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        maxDate={lastDay}
                      />
                    )}
                  </FormGroup>

                  {lead.quoted == 1 && (
                    <>
                      <Box>
                        <FormGroup dark style={{ alignItems: 'center' }}>
                          <AutocompleteField
                            medium
                            valueText={values.quoted_type || ''}
                            options={contact_type}
                            value={values.quoted_type || null}
                            varibleName="quoted_type"
                            onChange={(event, newValue, variable) => {
                              if (newValue) {
                                handleSetDefaultData(newValue.id, 'quoted_date');
                                handleChangeAutoComplete(event, newValue, variable);
                              }
                            }}
                            label="Forma que apresentou a proposta *"
                          />

                          <TextField
                            id="datetime-local"
                            label="Data da Cotação *"
                            type="datetime-local"
                            value={quotedDate || ''}
                            onChange={(e) => setQuotedDate(e.target.value)}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            maxDate={lastDay}
                          />
                        </FormGroup>
                      </Box>
                    </>
                  )}

                  {permissions?.can_finish && (
                    <Box>
                      <FormGroup dark>
                        <AutocompleteField
                          medium
                          valueText={selectedSold ? selectedSold.name : ''}
                          options={sold}
                          value={selectedSold || null}
                          varibleName="sold"
                          onChange={(event, newValue) => setSelectedSold(newValue)}
                          label="Status da venda *"
                        />
                        {selectedSold?.id == 1 && (
                          <AutocompleteField
                            medium
                            valueText={values.lost_sale ? values.lost_sale.name : ''}
                            options={lost_sale}
                            value={values.lost_sale || null}
                            varibleName="lost_sale"
                            onChange={handleChangeAutoComplete}
                            label="Motivo da não venda *"
                          />
                        )}
                        {selectedSold?.id == 2 && (
                          <AutocompleteField
                            medium
                            valueText={values.competitor_broker ? values.competitor_broker.name : ''}
                            options={competitor_broker}
                            value={values.competitor_broker || null}
                            varibleName="competitor_broker"
                            onChange={handleChangeAutoComplete}
                            label="Seguradora *"
                          />
                        )}

                        <AutocompleteField
                          medium
                          valueText={values.sold_type ? values.sold_type.name : ''}
                          options={contact_type}
                          value={values.sold_type || null}
                          varibleName="sold_type"
                          onChange={(event, newValue, variable) => {
                            if (newValue) {
                              handleSetDefaultData(newValue.id, 'sold_date');
                              handleChangeAutoComplete(event, newValue, variable);
                            }
                          }}
                          label="Forma que recebeu a resposta venda/não venda *"
                        />

                        <TextField
                          id="datetime-local"
                          label="Data da venda/não venda *"
                          type="datetime-local"
                          value={soldDate || ''}
                          onChange={(e) => setSoldDate(e.target.value)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          maxDate={lastDay}
                        />
                      </FormGroup>
                    </Box>
                  )}

                  {permissions?.can_finish && (
                    <Box>
                      <FormGroup dark>
                        {selectedSold?.id == 2 && (
                          <NumericFormat
                            label="Valor da venda *"
                            customInput={TextField}
                            decimalSeparator=","
                            thousandSeparator="."
                            decimalScale={2}
                            autoComplete="off"
                            InputProps={{
                              endAdornment: <InputAdornment position="start">R$</InputAdornment>,
                            }}
                            value={values.sale_value || ''}
                            onChange={(e) => setValues({ ...values, sale_value: e.target.value })}
                          />
                        )}
                        {selectedSold?.id == 2 && (
                          <TextField
                            value={values.commission_percentage || ''}
                            onChange={handleChange}
                            varibleName="commission_percentage"
                            label="Porcentagem de comissão *"
                            maxChars={3}
                            InputProps={{
                              endAdornment: <InputAdornment position="start">%</InputAdornment>,
                            }}
                          />
                        )}
                      </FormGroup>

                      <>
                        <Box>
                          <FormGroup dark style={{ alignItems: 'center' }}>
                            <AutocompleteField
                              medium
                              valueText={pagueMenos?.name || ''}
                              options={offer}
                              value={pagueMenos || null}
                              varibleName="pague_menos"
                              onChange={(event, newValue) => setPagueMenos(newValue)}
                              label="Seguro Franquia *"
                            />
                          </FormGroup>
                        </Box>

                        {/*
                    <Box>
                      <FormGroup dark style={{ alignItems: 'center' }}>
                        <AutocompleteField
                          medium
                          valueText={seguroConteudo?.name || ''}
                          options={offer}
                          value={seguroConteudo || null}
                          varibleName="seguro_conteudo"
                          onChange={(event, newValue) => setSeguroConteudo(newValue)}
                          label="Seguro Conteudo *"
                        />
                      </FormGroup>
                    </Box> */}
                      </>
                    </Box>
                  )}
                </div>
              </div>
            )}

            <div>
              <h2>Informações da Indicação F&I</h2>
              <div className="fi-referral-form">
                <div
                  className="fi-referral-form-notes"
                  hidden={!lead?.fi_referral_notes}
                  dangerouslySetInnerHTML={{ __html: lead?.fi_referral_notes?.replaceAll('\n', '<br/>') }}
                />

                <FormGroup dark>
                  <AutocompleteField
                    medium
                    options={crmContactAcceptedTypes}
                    value={values?.crm_contact_accepted || ''}
                    varibleName="crm_contact_accepted"
                    onChange={(event, newValue, variable) => {
                      handleChangeAutoComplete(event, newValue, variable);
                    }}
                    label="O vendedor F&I apresentou a Pêssego para o cliente?"
                  />
                </FormGroup>
              </div>
            </div>

            {values?.insurance?.id != '25' && (
              <div>
                <h2>Informações do Indicador</h2>
                <div className="form">
                  <FormGroup dark>
                    <AutocompleteField
                      medium
                      className="control g"
                      valueText={values.inviter ? values.inviter.name : ''}
                      options={usersData ? usersData?.filter((u) => u.roles[0]?.id !== 6) : [values.inviter]}
                      value={values.inviter || null}
                      varibleName="inviter"
                      onChange={handleChangeAutoComplete}
                      label="INDICADOR"
                      disabled={type === 'createUser' || (values.state && user?.role >= 2)}
                      required
                    />
                    <MaskedTextField
                      mask={
                        values.inviter_Phone && values.inviter_Phone.replace(/[^\d]/g, '').length < 11
                          ? '(99)9999-99999'
                          : '(99)99999-9999'
                      }
                      value={values.inviter_Phone || ''}
                      onChange={handleChange}
                      varibleName="inviter_Phone"
                      label="TELEFONE"
                      // disabled={values.state && user?.role >= 2}
                      disabled={type === 'createUser' || (values.state && user?.role >= 2)}
                      required
                    />
                  </FormGroup>

                  <FormGroup>
                    {/* ((values.inviter?.technical_team &&
                      values.inviter?.technical_team?.channels.find((ch) => ch.id === 1) !== null) ||
                      values.inviter?.channel.id === 1)  */}
                    {canRenderProposalSearch(values?.inviter) && (
                      <>
                        <Box
                          paddingX="5px"
                          color="#00000087"
                          display="flex"
                          my="auto"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          height="100%"
                          bgcolor="background.paper">
                          {!values.proposal && (
                            <p
                              style={{
                                fontFamily: 'Roboto',
                                fontSize: '0.8rem',
                                fontWeight: '400',
                                lineHeight: '1',
                                letterSpacing: '0.00938em',
                              }}>
                              PROPOSTA
                            </p>
                          )}
                          <IconButton aria-label="upload picture" component="span" onClick={handleOpenGetProposals}>
                            <SearchIcon />
                          </IconButton>
                        </Box>
                        {values.proposal && (
                          <TextFieldAdorned
                            className="control sm"
                            value={values.proposal || ''}
                            varibleName="proposal"
                            label="PROPOSTA"
                            error={createError}
                            disabled
                            endAdornment={
                              <InputAdornment position="start">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => {
                                    setValues({ ...values, proposal: '', partner: '', insurance: '' });
                                    setFillable(null);
                                  }}>
                                  {' '}
                                  <CloseIcon />
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        )}
                      </>
                    )}
                    {values.proposal && (
                      <>
                        <TextFieldAdorned
                          className="control g"
                          value={values.partner?.name || ''}
                          varibleName="partner"
                          label="EMPRESA NA QUAL TRABALHO"
                          // error={createError}
                          disabled
                          endAdornment={
                            <InputAdornment position="start">
                              <IconButton
                                aria-label="clear"
                                onClick={() => {
                                  setValues({ ...values, proposal: '', partner: '', insurance: '' });
                                  setFillable(null);
                                }}>
                                {' '}
                                <CloseIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        <TextFieldAdorned
                          className="control g"
                          value={values.insurance?.name || ''}
                          varibleName="insurance"
                          label="SETOR"
                          // error={createError}
                          disabled
                          endAdornment={
                            <InputAdornment position="start">
                              <IconButton
                                aria-label="clear"
                                onClick={() => {
                                  setValues({ ...values, proposal: '', partner: '', insurance: '' });
                                  setFillable(null);
                                }}>
                                {' '}
                                <CloseIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </>
                    )}
                  </FormGroup>
                </div>
              </div>
            )}

            <div>
              <h2>Informações do Indicado</h2>
              {((values.partner && values.insurance) || type == 'edit') && (
                <div className="form">
                  <FormGroup dark>
                    <MaskedTextField
                      mask={
                        values?.client_Cpf && values?.client_Cpf?.replace(/[^\d]/g, '').length < 12
                          ? '999.999.999-999'
                          : '99.999.999/9999-99'
                      }
                      value={values.client_Cpf || ''}
                      onChange={handleChange}
                      onBlur={async (e) => await checkCPF(e, values, setValues)}
                      varibleName="client_Cpf"
                      label="CPF/CNPJ"
                      className="control s"
                    />
                    <MaskedTextField
                      mask="999999999"
                      value={values.client_Rg || ''}
                      onChange={handleChange}
                      varibleName="client_Rg"
                      label="RG"
                      className="control s"
                    />
                    <TextField
                      value={values.client_name || ''}
                      onChange={handleChange}
                      varibleName="client_name"
                      label="NOME DO CLIENTE"
                      className="control gg"
                      required
                    />
                  </FormGroup>

                  <FormGroup dark>
                    <MaskedTextField
                      value={values.client_cellphone || ''}
                      onChange={handleChange}
                      varibleName="client_cellphone"
                      label="TELEFONE CELULAR"
                      required={
                        (!values.client_phone && !values.client_cellphone) ||
                        (!values.client_phone && !!values.client_cellphone)
                      }
                      mask={
                        values.client_cellphone && values.client_cellphone.replace(/[^\d]/g, '').length < 11
                          ? '(99)9999-99999'
                          : '(99)99999-9999'
                      }
                    />
                    <MaskedTextField
                      value={values.client_phone || ''}
                      onChange={handleChange}
                      varibleName="client_phone"
                      label="TELEFONE FIXO"
                      required={
                        (!values.client_phone && !values.client_cellphone) ||
                        (!!values.client_phone && !values.client_cellphone)
                      }
                      mask={
                        values.client_phone && values.client_phone.replace(/[^\d]/g, '').length < 11
                          ? '(99)9999-99999'
                          : '(99)99999-9999'
                      }
                    />
                    <MaskedTextField
                      value={formatDate(values.client_birth_date) || ''}
                      onChange={handleChange}
                      varibleName="client_birth_date"
                      label="DATA DE NASCIMENTO"
                      mask={'99/99/9999'}
                    />
                  </FormGroup>

                  <FormGroup dark>
                    <MaskedTextField
                      value={values.client_CEP || ''}
                      onChange={handleChange}
                      onBlur={() => checkCEP(values, setValues)}
                      varibleName="client_CEP"
                      label="CEP"
                      className="control s"
                      mask="99999-999"
                    />
                    <TextField
                      value={values.client_address_street || ''}
                      onChange={handleChange}
                      varibleName="client_address_street"
                      label="Logradouro"
                      className="control xl"
                    />
                    <TextField
                      value={values.client_address_number || ''}
                      onChange={handleChange}
                      varibleName="client_address_number"
                      label="Número"
                      type="number"
                      className="control s"
                    />
                    <TextField
                      value={values.client_address_comp || ''}
                      onChange={handleChange}
                      varibleName="client_address_comp"
                      label="Complemento"
                      className="control s"
                    />
                  </FormGroup>
                  <FormGroup dark>
                    <TextField
                      value={values.client_address_state || ''}
                      onChange={handleChange}
                      varibleName="client_address_state"
                      label="Estado"
                      className="control ms"
                    />
                    <TextField
                      value={values.client_address_district || ''}
                      onChange={handleChange}
                      varibleName="client_address_district"
                      label="Bairro"
                    />
                    <TextField
                      value={values.client_address_city || ''}
                      onChange={handleChange}
                      varibleName="client_address_city"
                      label="Cidade"
                    />
                  </FormGroup>

                  <FormGroup dark>
                    <TextField
                      value={values.client_Email || ''}
                      onChange={handleChange}
                      varibleName="client_Email"
                      label="E-MAIL"
                      className="control gg"
                      required
                    />

                    <AutocompleteField
                      medium
                      className="control m"
                      valueText={values.insurance_expiration ? values.insurance_expiration.name : ''}
                      options={months}
                      value={values.insurance_expiration || null}
                      varibleName="insurance_expiration"
                      onChange={handleChangeAutoComplete}
                      label="JÁ POSSUI SEGURO, QUAL O MÊS DO VENCIMENTO"
                    />
                  </FormGroup>

                  <FormGroup>
                    <TextField
                      type="datetime"
                      value={(values.proposal_date && values.proposal_date.replace('T', ' ')) || ''}
                      onChange={handleChange}
                      varibleName="proposal_date"
                      label="DATA DA PROPOSTA"
                      disabled
                      // required
                    />
                    <TextField
                      value={values.product || ''}
                      onChange={handleChange}
                      varibleName="product"
                      label={car ? 'MODELO DO VEÍCULO' : 'PRODUTO SEGURADO'}
                    />
                    {car && (
                      <TextField
                        value={values.product_brand || ''}
                        onChange={handleChange}
                        varibleName="product_brand"
                        label="MARCA"
                        required={car}
                      />
                    )}
                  </FormGroup>

                  {car && (
                    <FormGroup>
                      <TextField
                        value={values.product_chassis || ''}
                        onChange={handleChange}
                        varibleName="product_chassis"
                        label="CHASSI DO VEÍCULO"
                        required={
                          ((values.insurance?.id != 1 || values.insurance?.id != 3) &&
                            !values.product_chassis &&
                            !values.product_license_plate) ||
                          values.product_chassis
                        }
                      />
                      <TextField
                        value={values.product_license_plate || ''}
                        onChange={handleChange}
                        varibleName="product_license_plate"
                        label="PLACA DO VEÍCULO"
                        required={!values.product_chassis && (values.insurance?.id != 1 || values.insurance?.id != 3)}
                      />
                      <TextField
                        value={values.product_year || ''}
                        onChange={handleChange}
                        varibleName="product_year"
                        label="ANO DE MODELO DO VEÍCULO"
                        required={car}
                      />
                    </FormGroup>
                  )}

                  <FormGroup>
                    <TextField
                      value={values.product_details || ''}
                      onChange={handleChange}
                      varibleName="product_details"
                      label={car ? 'OUTRAS INFORMAÇÕES DO VEÍCULO SEGURADO' : 'OUTRAS INFORMAÇÕES DO PRODUTO SEGURADO'}
                      multiline
                      rows={5}
                    />
                  </FormGroup>

                  <FormGroup>
                    <TextField
                      value={values.additional_information || ''}
                      onChange={handleChange}
                      varibleName="additional_information"
                      label="OBSERVAÇÕES"
                      multiline
                      rows={5}
                    />
                  </FormGroup>

                  <FormGroup>
                    <TextField value={values.nps_value || ''} disabled label="Nota NPS" type="numeric" rows={5} />
                  </FormGroup>

                  <div className="buttonContainer">
                    {leadCurrent?.file_path && (
                      // <a href='/somefile.txt' download>Click to download</a>
                      <Button
                        onClick={downloadFile}
                        component="label"
                        variant="contained"
                        color="default"
                        className="of-file"
                        startIcon={<GetApp />}>
                        Download Arquivo
                      </Button>
                    )}

                    <Button
                      onChange={fileUpload}
                      component="label"
                      variant="contained"
                      color="default"
                      className="of-file"
                      startIcon={<CloudUploadIcon />}>
                      Enviar Arquivo
                      <input type="file" accept="application/pdf" hidden />
                    </Button>
                  </div>
                </div>
              )}
            </div>
            <ButtonDiv />
            <button ref={form} type="submit" hidden>
              hidden save
            </button>
          </form>
        </Container>
      )}
    </>
  );
}

LeadForm.propTypes = {
  type: P.oneOf(['edit', 'createUser', 'createAdmin']).isRequired,
  setOpen: P.func,
  leadCurrent: P.shape({
    id: P.number,
    proposal: P.number,
    foreign_proposal: P.number,
    product: P.string,
    product_details: P.oneOfType([P.arrayOf(P.any), P.objectOf(P.any)]),
    channel_id: P.number,
    client_id: P.number,
    broker_id: P.number,
    inviter_id: P.number,
    status: P.number,
    state: P.number,
    insurance_id: P.number,
    insurance_expiration: P.number,
    partner: P.objectOf(P.any),
    broker: P.objectOf(P.any),
    channel: P.objectOf(P.any),
    client: P.objectOf(P.any),
    client_adress: P.objectOf(P.any),
    inviter: P.objectOf(P.any),
    inviter_Phone: P.string,
    partner_id: P.number,
    additional_information: P.string,
    proposal_date: P.string,
    contact_type: P.number,
    sold: P.number,
    lost_sale: P.number,
    quoted: P.number,
    pague_menos: P.number,
    seguro_conteudo: P.number,
    backup_car: P.number,
    competitor_broker: P.number,
    attendance_on_time: P.number,
    indication_on_time: P.number,
    create_lead_date: P.string,
    end_lead_date: P.string,
    first_call_date: P.string,
    lead_scheduling: P.objectOf(P.any),
  }),
};
LeadForm.defaultProps = {
  leadCurrent: null,
  setOpen: () => {},
};
